/** Lists page — the "filter by source" palette (`list.sourceFilter`). */
export const enListSourceFilter = {
	trigger: "Source",
	title: "Filter by source",
	searchPlaceholder: "Search source types…",
	all: "All sources",
	allDescription: "Show lists from every source type",
	empty: "No source type matches your search",
	footerHint: "↑ ↓ to navigate · ↵ to select",
	count: "{{count}} sources",
	sources: {
		LI_SN: {
			label: "LinkedIn Sales Navigator",
			description: "Import lists built in LinkedIn Sales Navigator",
		},
		LI_PEOPLE: {
			label: "LinkedIn People Search",
			description: "Import results from a LinkedIn people search",
		},
		LI_EVENTS: {
			label: "LinkedIn Events",
			description: "People attending LinkedIn events & webinars",
		},
		LI_POST: {
			label: "LinkedIn Posts",
			description: "People who post about or engage with a topic",
		},
		LI_COMPANY_ACTIVITY: {
			label: "LinkedIn Company Followers",
			description: "New followers of your LinkedIn company page",
		},
		LI_PROFILE_VISITS: {
			label: "LinkedIn Profile Visits",
			description: "Visitors of your personal LinkedIn profile",
		},
		CSV_ENRICHMENTS: {
			label: "Excel / CSV Upload",
			description: "Enrich an uploaded XLSX of people, companies or titles",
		},
		CUSTOM_EVENTS: {
			label: "Scraping as a Service",
			description: "We scrape attendee or exhibitor lists for you",
		},
		LEAD_DATABASE: {
			label: "Lead Database",
			description: "Contacts pulled from our lead database",
		},
		COMPANY_ENRICH: {
			label: "Lead Database",
			description: "Find leads at companies matching your criteria",
		},
		MAPS: {
			label: "Google Maps",
			description: "Local businesses found via Google Maps",
		},
		PARALLEL_AI: {
			label: "AI Prompt",
			description: "Companies found by an AI prompt or news monitor",
		},
		JOBS: {
			label: "Jobs / Hiring",
			description: "Companies hiring for the roles you target",
		},
		JOB_CHANGE: {
			label: "Job Change Tracking",
			description: "Contacts who recently changed jobs or roles",
		},
		FUNDING_ROUNDS: {
			label: "Funding Rounds & M&A",
			description: "Companies that raised funding or were acquired",
		},
		TRACKER: {
			label: "Custom Signal Tracker",
			description: "Your custom signal tracker lists",
		},
		SMART_LIST: {
			label: "Smart List",
			description: "Recurring re-engagement smart lists",
		},
	},
};
